var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"richtext",staticClass:"richtext-container",domProps:{"innerHTML":_vm._s(_vm.richtext)}})
}
var staticRenderFns = []

export { render, staticRenderFns }